import React from 'react';
import './styles.css';

/**
 * 狀態標籤組件
 * 用於顯示保養單狀態
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.status - 狀態值
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 狀態標籤組件
 */
function StatusBadge({ status, className = '' }) {
    // 獲取狀態的中文名稱
    const getStatusName = (status) => {
        switch (status) {
            case 'Pending': return '待驗證';
            case 'Approved': return '已通過';
            case 'Rejected': return '已拒絕';
            case null:
            case undefined:
                return '待驗證';
            default: return status || '待驗證';
        }
    };

    // 獲取狀態的CSS類名
    const getStatusClass = (status) => {
        switch (status) {
            case 'Pending': return 'status-pending';
            case 'Approved': return 'status-approved';
            case 'Rejected': return 'status-rejected';
            case null:
            case undefined:
                return 'status-pending';
            default: return 'status-pending';
        }
    };

    return (
        <span className={`status-badge ${getStatusClass(status)} ${className}`}>
            {getStatusName(status)}
        </span>
    );
}

export default StatusBadge; 